export default [
  {
    title: 'درخواست ها',
    icon: 'SendIcon',
    children: [
      {
        title: 'درخواست جدید',
        icon: 'Edit3Icon',
        route: 'Requests_Create',
        permission: 'requests.store',
      },
      {
        title: 'لیست درخواست ها',
        icon: 'SendIcon',
        route: 'Requests_Sent',
        permission: 'requests.index',
      },
      {
        title: 'درخواست های ورودی',
        icon: 'InboxIcon',
        route: 'Requests_Inbox',
        permission: 'requests.inbox',
      },
      {
        title: 'آرشیو ورودی',
        icon: 'ArchiveIcon',
        route: 'Requests_Archive',
        permission: 'requests.archive',
      },

    ],
  },
]
